import { IFalconTheme } from '@se-admin/falcon';
import * as React from 'react';
import { IAffiliateDetails } from '../../common/contexts/ApplicationContext';
import { ITranslationObject } from '../../common/types/index';
import { ApplicationContainer } from '../Application';
import Proposition from '../Proposition/Proposition';
import RecommendedSales from '../RecommendedSales/RecommendedSales';
import { ExpiredSalePageWrapper, RecomendationWrapper } from './ExpiredSalePage.style';

export interface IExpiredSalePageProps {
  theme?: IFalconTheme;
  saleId: string;
  userId?: string;
  userTerritory?: string;
  affiliate: IAffiliateDetails;
  territory: string;
  currency: string;
  apiUrl?: string;
  translationObject: ITranslationObject;
  viewAllSalesUrl: string;
}

/**
 * Shows recommended sales and proposisiton for the top of the expired sale page.
 */
function ExpiredSalePage(props: IExpiredSalePageProps) {
  return (
    <ApplicationContainer
      territory={props.territory}
      userTerritory={props.userTerritory}
      affiliate={props.affiliate.urlString}
      currency={props.currency}
      apiUrl={props.apiUrl}
      theme={props.theme}
      translationObject={props.translationObject}
      isOpenSite={props.affiliate.isOpenSite}
      userId={props.userId}
    >
      <ExpiredSalePageWrapper data-testid="expiredSalePage">
        <RecomendationWrapper>
          <RecommendedSales
            saleId={props.saleId}
            affiliate={props.affiliate}
            territory={props.territory}
            viewAllSalesUrl={props.viewAllSalesUrl}
          />
        </RecomendationWrapper>
        <Proposition />
      </ExpiredSalePageWrapper>
    </ApplicationContainer>
  );
}

export default ExpiredSalePage;
